module.exports = __webpack_public_path__ + "static/media/flags.9c74e172.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/images/flags.png
// module id = 4403
// module chunks = 0